// extracted by mini-css-extract-plugin
export default {"inputLabel":"InputLabel_inputLabel__cfIO8","right":"InputLabel_right__qBS0M","left":"InputLabel_left__DLjGt"};